import { Typography } from "@mui/material";

export const MessageDisplay = ({ message, open, ...rest }) => {
    if (open) {
    return <Typography {...rest}>{message}</Typography>;
  } else {
    return null
  }
};
